import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { retry, catchError, map } from 'rxjs/operators';
import { environment } from '@environments/environment';

@Injectable({ providedIn: 'root' })
export class FormsService {
    constructor(
        private http: HttpClient
    ) { }

    saveOpportunity(data): Observable<any> {
        let headers = new HttpHeaders({
            'Content-Type': 'application/json'
        });

        let options = { headers: headers };

        return this.http.post<any>(environment.scs_url + '/forms/create', JSON.stringify(data), options)
            .pipe(
                retry(1),
                catchError(this.errorHandle)
            );
    }

    saveFileInSf(data): Observable<any> {
        let headers = new HttpHeaders({
            'Content-Type': 'application/json'
        });

        let options = { headers: headers };

        return this.http.post<any>(environment.scs_url + '/api/upload_file_sf', JSON.stringify(data), options)
            .pipe(
                retry(1),
                catchError(this.errorHandle)
            );
    }

    errorHandle(error: any) {
        let errorMessage = '';
        if (error.error instanceof ErrorEvent) {
            // Get client-side error
            errorMessage = error.error.message;
        } else {
            // Get server-side error
            errorMessage = `Error Code: ${error.status}\nMessage: ${error.message}`;
        }
        console.log(errorMessage);
        return throwError(errorMessage);
    }
}
